'use strict';

import { get } from 'Data/SystemREST';
import GenericTableData from './GenericTableData';

// Resource Module Event Bus.
let ResourceData = GenericTableData.getTableDataBus('RES', 'resources');

ResourceData.getResourceAndAssociations = (id) => {
  return ResourceData.getRecord(id, {
    _include: 'organizations,$service_contract_details.service_contracts',
  });
};

ResourceData.getResourcesForOrg = (orgId) => {
  return (
    orgId &&
    ResourceData.getRecordList(
      {
        where: {
          '*parent_organization_id': orgId,
        },
        _sort: 'name',
        _pageSize: 1000,
      },
      false,
      'RES_LIST_FOR_CORE_LOADED',
    )
  );
};

ResourceData.getAllResources = () => {
  return ResourceData.getAllRecords({
    fields: 'name,description',
  });
};

ResourceData.getAssetInformation = (tagNumber) => {
  let requestURL = `/inventory/search/${tagNumber}`;
  return get(requestURL).then((res) => {
    let payload = res.body;
    if (payload) {
      ResourceData.notifyListeners('ASSET_DETAILS_RETRIEVED', payload);
      return Promise.resolve(payload);
    }
  });
};

ResourceData.linkAssetInventoryPage = (tagNumber) => {
  let requestURL = `/inventory/${tagNumber}`;
  return get(requestURL).then((res) => {
    let invURL = res?.text;
    invURL && window.open(invURL, '_blank').focus();
    return invURL;
  });
};

let exportCols = [
  { key: 'id', header: 'ID' },
  { key: 'name', header: 'Name' },
  { key: 'description', header: 'Description' },
  { key: 'organization', header: 'Core Facility' },
  { key: 'inventory_tag_number', header: 'Inventory Tag #' },
];

ResourceData.exportResourceList = (opts) => {
  ResourceData.exportRecordList({ ...opts, columns: exportCols });
};
export default ResourceData;
